import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AnonymousGuard, AuthenticatedGuard } from '@smatchy/ionic-auth';
import { RouteRedirectGuard } from './core/utils/route-redirect.guard';

export const routes: Routes = [
  {
    path: 'group',
    canActivate: [RouteRedirectGuard],
    children: [],
  },
  {
    path: 'group/:id',
    canActivate: [RouteRedirectGuard],
    children: [],
  },
  {
    path: 'detail-activity',
    canActivate: [RouteRedirectGuard],
    children: [],
  },
  {
    path: 'detail-activity/:id',
    canActivate: [RouteRedirectGuard],
    children: [],
  },
  {
    path: 'explore',
    canActivate: [RouteRedirectGuard],
    children: [],
  },
  {
    path: '',
    loadChildren: () => import('./presentations/pages/logged/logged.module').then((m) => m.LoggedModule),
    canActivate: [AuthenticatedGuard],
    canActivateChild: [AuthenticatedGuard],
  },
  {
    path: 'auth',
    loadChildren: () => import('./presentations/pages/auth/auth.module').then((m) => m.AuthModule),
    canActivate: [AnonymousGuard],
    canActivateChild: [AnonymousGuard],
  },
  /*
   * An address no route knows goes home instead of throwing NG04002
   * (CAPACITOR-E). On Android every smatchy.app link opens the app, so a
   * mistyped or retired path would otherwise leave the person where they were.
   * Last on purpose: the empty path above matches the start of every address,
   * and this one is only reached once nothing under it matched.
   */
  { path: '**', redirectTo: '' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
